module.exports = __webpack_public_path__ + "static/media/ajax-Loader.7bc2ade9.gif";